import { isFunction } from './typeChecks';

var pipe = function pipe(start) {
  var initialValue = isFunction(start) ? start() : start;

  for (var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }

  return fns.reduce((pipedValue, fn) => fn(pipedValue), initialValue);
};

export { pipe };